__turbopack_context__.v({
  "actions": "DmsFinalCta-module__JgCAGW__actions",
  "btn": "DmsFinalCta-module__JgCAGW__btn",
  "btnPrimary": "DmsFinalCta-module__JgCAGW__btnPrimary",
  "btnSecondary": "DmsFinalCta-module__JgCAGW__btnSecondary",
  "card": "DmsFinalCta-module__JgCAGW__card",
  "eyebrow": "DmsFinalCta-module__JgCAGW__eyebrow",
  "head": "DmsFinalCta-module__JgCAGW__head",
  "inView": "DmsFinalCta-module__JgCAGW__inView",
  "particles": "DmsFinalCta-module__JgCAGW__particles",
  "section": "DmsFinalCta-module__JgCAGW__section",
  "spinAccent": "DmsFinalCta-module__JgCAGW__spinAccent",
  "subtitle": "DmsFinalCta-module__JgCAGW__subtitle",
  "title": "DmsFinalCta-module__JgCAGW__title",
  "wrap": "DmsFinalCta-module__JgCAGW__wrap",
});
